<!--
 * @Deccription: 外链文件夹里的文件预览
 * @Author: zjg
 * @Date: 2020-02-18 14:21:56
 * @LastEditTime: 2020-02-25 19:12:16
 -->
<template>
  <!-- 外链文件夹里的文件预览-->
  <div
    class="link-box"
    style="width: 100%; height: 100%"
  >
    <!--外链下载 iframe-->
    <iframe
      id="download-iframe"
      src="javascript:false;"
      width="0"
      heigth="0"
      border="none"
      style="display:none"
    />
    <!-- 容器整体的部局 bs-structure组件的prop请仔细哦-->
    <bs-structure
      :display-right="displayRightPanel"
      :is-full-screen="isFullScreen"
      :box-margin-r="20"
      :box-margin-l="20"
    >
      <!-- header -->
      <template slot="boxHeader">
        <bsHeader
          :is-logo="false"
          :data="metaData"
        >
          <div class="fl-r lh-50">
            <co-button
              v-if="topBtnPower.showDown"
              @click="downFile"
            >
              {{ $t('下载') }}
            </co-button>
            <!--<co-button-->
              <!--v-if="topBtnPower.showSlideBtn"-->
              <!--@click="slideModeHandler"-->
            <!--&gt;-->
              <!--{{ isSideMode?$t('预览模式'):$t('幻灯片模式') }}-->
            <!--</co-button>-->
            <co-button
self-class="right-pannel c-btn"
@click="toggleRightPanel"
>
                            <template name="default">
                                <svg class="right-pannel-icon">
                                    <use :xlink:href="displayRightPanel ? '#retractRightcolumn' : abnormalType==='noAccess'? '#disExpendRightcolumn':'#expendRightcolumn'" />
                                </svg>
                            </template>
                        </co-button>
          </div>
        </bsHeader>
      </template>
      <!-- body -->
      <template slot="boxBody">
        <div
          ref="linkBoxBody"
          class="link-box-body"
        >
          <!--上部预览-->
          <div
            class="link-box-main"
            :style="{height:isShowFoot?'calc(100% - 50px)':'100%'}"
          >
            <clientGuidPreview :file-info="clientToWebInfo" v-if="clientToWebVisible"/>
            <!-- 正常预览 -->
            <bs-switch
              v-else-if="!abnormalType"
              ref="bsswitch"
              :is-side-mode="isSideMode"
              :is-delivery="true"
              @loadFail="loadFail"
            />
            <!-- 异常预览提示 -->
            <bs-abnormal
              v-else
              :data="metaData"
              :type="abnormalType"
              :abnormal-data="abnormalData"
              @abnormal="abnormal"
            />
          </div>
          <!--下部底部栏-->
          <div
            v-show="isShowFoot"
            :class="['link-box-footer common-transion', displayFooterScroller ? 'footer-float' : '']"
          >
            <div class="footer-toolbar">
              <!-- 左部区域 -->
              <div
                ref="sectionUp"
                class="section-up cp"
              >
                <span
                  :class="['previous-one hv-ac', (hasPre? '':'inactive-mode')]"
                  @click="goto(-1)"
                >
                  <svg class="item-icon">
                    <use :xlink:href="hasPre? '#previousOne':'#disPreviousOne'" />
                  </svg>
                  <span class="previous-one-text">{{ $t('上一个') }}</span>

                </span>
              </div>
              <!-- 右部区域 -->
              <div
                ref="sectionDown"
                class="section-down"
              >
                <span
                  class="switch-list hv-ac cp"
                  @click="toggleFooterScroller"
                >{{ displayFooterScroller? $t('收起列表') : $t('展开列表') }}</span><!--
                                 --><bs-featureguide
v-model="guideArr[0].isShow"
:guide-key="guideArr[0].guideKey"
:is-auto-run="false"
>
<!--
                                    --><bs-upmenu
:list="typeList"
:only-up="true"
:is-right="true"
@click-item="changeVal"
>
                                            <template slot="btname">
                                                <span class="selector-type">{{ $t(listVal.type) }}</span>
                                                <span class="selector-pos">: {{ listVal.curNum }}/{{ listVal.totalNum }}</span>
                                            </template>
                                        </bs-upmenu><!--
                                -->
                </bs-featureguide><!--
                                --><span
:class="['next-one hv-ac cp', (hasNext? '':'inactive-mode')]"
@click="goto(1)"
>
                                    <span class="next-one-text">{{ $t('下一个') }}</span><!--
                                --><svg class="item-icon">
                                        <use :xlink:href="hasNext? '#nextOne':'#disNextOne'" />
                                    </svg>
                                </span>
              </div>
              <!-- 中间控制预览的操作区域 -->
              <div class="section-toolbar">
                <bs-PdftoolBar
                  ref="pdftoolbar"
                  :data="metaData"
                  :doc-check="docCheck"
                  :pic-check="picCheck"
                  @presentationMode="presentationMode"
                />
              </div>
            </div>
            <!--file list scroller -->
            <div class="footer-thumbnail">
              <bs-thumbnail
                ref="thumbnail"
                :is-delivery="true"
                :is-show="displayFooterScroller"
                :is-show-right="displayRightPanel"
                :step="fileListStep"
                :req-param="reqParam"
                :is-full-screen="isFullScreen"
                @load="onLoading"
                @deleteFileItem="deleteFileItem"
                @getSelectedData="getSelectedData"
              />
            </div>
          </div>
        </div>
      </template>
      <template slot="boxRight">
        <!--right panel-->
        <div
          v-show="displayRightPanel"
          class="link-right"
        >
          <bsFlinkRight :data="metaData" />
        </div>
      </template>
    </bs-structure>
  </div>
</template>
<script>
import bsStructure from 'components/business/structure/index.vue'
import bsLinkRight from 'components/business/link/linkright/index.vue'
import bsFlinkRight from 'components/business/link/flinkright/index.vue'
import bsHeader from 'components/business/link/header/index.vue'
import bsSwitch from 'components/business/switch/index.vue'
import bsAbnormal from 'components/business/abnormal/index.vue'
import bsPdftoolBar from 'components/business/pdftoolbar/index.vue'
import bsUpmenu from 'components/business/upmenu/index.vue'
import bsThumbnail from 'components/business/thumbnail/index.vue'
import coButton from 'components/common/button/index.vue'
import clientGuidPreview from 'components/business/client-guide-preview/client-guide-preview.vue'

import {
  isExcel, typeIcon, isClient, resolveFileAction, getPreviewType, exitFullscreen,
} from 'js/util/util'
import { linkDownLoad } from 'js/api/download/linkDown.js'
import bsFeatureguide from 'components/business/featureguide/index.vue'
import { PREVIEW } from 'js/mixin/common.js'
import { LINKFILE } from 'js/mixin/linkcommon.js'
import { EventBus } from "js/util/event-bus.js"

const { getData, getUrl, formatUrl } = require('js/api/getdata').default

export default {
  components: {
    bsFeatureguide,
    bsStructure,
    bsLinkRight,
    bsHeader,
    bsSwitch,
    bsAbnormal,
    bsPdftoolBar,
    bsUpmenu,
    bsThumbnail,
    bsFlinkRight,
    coButton,
    clientGuidPreview,
  },
  /**
         * 主要混入的函数
         * showFoot
         * footMouseMove
         * pushEsc
         * checkfull
         * LINKFILE中:
         * linkPreviewLimit
         * accountSupport
         * nonTrialAccount
         * typeSupport
         * checkPreSupport
         * showAbornomal
         */
  mixins: [PREVIEW, LINKFILE],
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      displayRightPanel: true, // 默认展开右侧栏
      abnormalType: '', // 异常组件
      isSideMode: false, // 是否正在幻灯片模式预览
      displayFooterScroller: false, // 是否显示底部的滚动列表
      isShowFoot: true, // 是否显示底部栏
      hasPre: false, // 是否有上一个
      hasNext: false, // 是否有下一个
      typeList: [], // 过滤全部类型
      allTypeList: [ // 全部类型
        { name: '全部类型', key: 'all', type: -1 },
        { name: '图片', key: 'pic', type: 4 },
        { name: '文档', key: 'file', type: 1 },
        { name: '视频', key: 'video', type: 3 },
        { name: '音频', key: 'audio', type: 2 },
        { name: '其他', key: 'other', type: 0 },
      ],
      listVal: { // 文件类型选择器
        type: '全部类型',
        curNum: 0,
        totalNum: 0,
      },
      reqParam: {}, // 请求底部列表的参数
      selectedData: {}, // 当前底部列表选中的数据
      fileListStep: 0, // 记录上/下一个切换变化
      code: '', // delivery_code
      metaData: {}, // 文件的metadata信息
      metadata_url: '', // 文件信息的接口地址
      parsedParam: {}, // other参数,
      topBtnPower: {
        showDown: false, // 显示下载按钮
        showSlideBtn: false, // 显示ppt模式按钮
      },
      // 链接数据
      shareInfo: {
        isSecurity: false, // 安全外链
        isApprove: false, // 审批外链
        isTrial: false, // 体验用户
      },
      abnormalData: {}, // 异常需要的额外数据
      clientToWebVisible: false,
      clientToWebInfo: {},
    }
  },
  computed: {
    guideArr() {
      return this.$store.state.guideArr
    },
  },
  watch: {
    /**
             * 切换换灯片模式的预览
             */
    isSideMode(n, o) {
      this.$store.commit('GET_IS_SIDEMODE', n)
      // this.$refs.bsswitch.init()
    },
  },
  created() {
    this.init(true)
    // 当多个新手引导时执行
    // this.$store.dispatch('getGuide')
  },
  mounted() {
    window.addEventListener('message', this.viewError, false)
  },
  destroyed() {
    window.removeEventListener('message', this.viewError)
  },
  methods: {
    /**
             * 幻灯片模式的切换
             */
    slideModeHandler() {
      this.isSideMode = !this.isSideMode
      this.$refs.bsswitch.init()
    },
    /**
             * 设置顶部按钮显示的方法
             */
    getTopBtnShow(data) {
      const power = resolveFileAction(data.access_mode)
      // 含有下载权限，并且该文件不是apk类型的文件
      if (/download/.test(power) && !/\.apk$/.test(data.mime_type)) {
        this.topBtnPower.showDown = true
      }
      if (/ppt|dps/i.test(data.mime_type) && !isClient()) {
        this.topBtnPower.showSlideBtn = true
      }
    },
    /**
             * 初始化数据
             * 切换时，重置一些数据
             */
    initData() {
      this.abnormalType = '' // 可以预览时，不显示异常
      this.isSideMode = false // 非幻灯片模式
      this.topBtnPower.showDown = false // 头部按钮显示，下载
      this.topBtnPower.showSlideBtn = false // 头部按钮显示，幻灯片模式
    },
    guideToWeb(metaPromise) {
      if (isClient() && metaPromise && metaPromise.data) {
        const { mime_type: mineType, size, path } = metaPromise.data
        const iconType = typeIcon(mineType.split('.').pop())
        const toWebType = ['video', 'music']
        if (toWebType.includes(iconType)) {
          this.clientToWebVisible = true
          this.clientToWebInfo = {
            iconType,
            filename: path.split('/').pop(),
            size,
          }
        } else {
          this.clientToWebVisible = false
        }
      }
    },
    /**
             * 初始化
             * @param {Boolean} reqFileList 是否请求底部的文件列表，lifecycle created时候请求，路由更新的时候不用
             */
    async init(reqFileList = false) {
      const param = this.$route.params || {}
      const { neid } = param
      const other = JSON.parse(this.$route.query.other)
      const url = formatUrl(`/delivery/actionView/${other.code}`)
      // 请求外链信息并返回相应的状态
      let d = await getData(url)
      d = d.data
      if(d.code === '10008'){
        this.$router.push({ path: `/link/user/prelogin/${other.code}`, query: { body: { ext:d.data } } })
      }
      // 将页签的title设置为用户自定义的title(兼容外链页面未登录的情景)
      document.title = (d.data || {}).title;
      this.initData() // 重置数据
      this.getListOther() // 获取other参数
      let res = {} // meta请求的response
      try {
        res = await this.getMetaData() // 获取文件的meta信息
        this.guideToWeb(res)
      } catch (e) {
        console.log('here some error happens', e, e.response)
        const error = (e.response && e.response.data) || {}
        const state = error.state || '500'
        const errCfg = {
          403: { type: 'linkNoAccess', showFooter: false }, // 没有权限
          404: { type: 'invalidLose', showFooter: true }, // 被删除
          409: { type: 'lowSecret', showFooter: false }, // 低密级
          500: { type: 'loadFail', showFooter: true }, // 加载失败
        }
        this.abnormalType = errCfg[state].type // 异常类型
        this.displayRightPanel = false // 不显示右侧栏
        this.isShowFoot = errCfg[state].showFooter // 是否显示底部栏
        this.metaData = {}
        this.mergeData()
        if (reqFileList) {
          this.initReqParam() // 初始化底部列表的请求参数
        }
        if (this.isFullScreen) { // meta报错时，如果是全屏状态，那退出全屏
          exitFullscreen() // 退出全屏
          this.isFullScreen = false
          this.$nextTick(() => {
            this.displayRightPanel = false // 不显示右侧栏
          })
        }
        return
      }
      this.metaData = Object.prototype.toString.call(res.data) === '[object Object]' ? res.data : {}
      this.mergeData()
      this.shareInfo.isTrial = this.metaData.is_trial
      this.metaData.shareInfo = this.shareInfo // 把链接信息（审批，安全，体验）拼给metaData
      this.$store.commit('GET_CUR_FILE_INFO', this.metaData) // 存store，在底部toolbar有用到meta信息
      if (reqFileList) {
        this.initReqParam() // 初始化底部列表的请求参数
      }
      const preSupport = await this.checkPreSupport() || {}
      this.getTopBtnShow(this.metaData) // 头部按钮如何显示
      if (preSupport.canPreview) { // 正常预览
        this.setToolbarMedia('linkBoxBody') // toolbar媒体查询
        this.$nextTick(() => {
          EventBus.$emit('itemChange', true)
          this.$refs.bsswitch.startPreview(this.metaData) // 开始预览
        })
        return
      }
      // 异常
      this.showAbornomal(preSupport)
    },
    /**
             * 获取meta信息
             */
    async getMetaData() {
      const vm = this
      let d = null
      if (this.parsedParam.password) {
        d = await getUrl(`${vm.metadata_url}&interface_version=2020&neid=${vm.$route.params.neid}`)
      } else {
        d = await getUrl(`${vm.metadata_url}?interface_version=2020&neid=${vm.$route.params.neid}`)
      }
      return d
    },
    /**
             * 混合meta信息和other参数里带来的信息
             */
    mergeData() {
      const previewData = { // 预览所需的参数，融合到metadata中，在预览页用到
        folder_id: this.code || '',
        token: this.parsedParam.token || '',
        password: this.parsedParam.password || '',
        path: this.metaData.path || this.parsedParam.path || '',
      }
      Object.assign(this.metaData, previewData)
      // console.log('meta===', this.metaData)
    },
    downFile() {
      if (Object.keys(this.metaData).length < 1) {
        // 弹窗提示警告信息
        this.$toast.simpleShow('目标文件禁止此操作', 'warn')
        return
      }
      // 下载数据
      linkDownLoad(this.shareInfo, this.metaData, [this.metaData])
    },
    /**
             * toggle 右侧栏
             */
    toggleRightPanel() {
      this.displayRightPanel = !this.displayRightPanel
      this.setToolbarMedia('linkBoxBody') // toolbar媒体查询
    },
    /**
             * toggle 底部收缩框
             */
    toggleFooterScroller() {
      this.displayFooterScroller = !this.displayFooterScroller
    },
    /**
             * upmenu组件 接收文件类型的数据
             */
    changeVal(val) {
      this.initReqParam(val.type)
    },
    /**
             * 从url的other里获取底部滚动文件列表所需参数
             */
    getListOther() {
      const other = this.$route.query && this.$route.query.other
      let otherParsed = {}
      try {
        otherParsed = JSON.parse(other)
      } catch (e) {
        // 这里必须取到delivery_code,否则列表没有
        console.log('you file cannot resolve \'other\' params')
      }
      this.parsedParam = otherParsed
      this.code = this.parsedParam.code
      const metaurlArr = this.parsedParam.metadata_url.split('/')
      const metaurlPath = metaurlArr.pop()
      if (metaurlPath.indexOf('?') > -1) {
        const fileName = encodeURIComponent(metaurlPath.substr(0, metaurlPath.indexOf('?')))
        const token = metaurlPath.substr(metaurlPath.indexOf('?'))
        this.metadata_url = `${metaurlArr.join('/')}/${fileName}${token}`
      } else {
        this.metadata_url = `${metaurlArr.join('/')}/${encodeURIComponent(metaurlPath)}`
      }
    },
    /**
             * 删除object里的key
             */
    deletePropertyInObj(obj, key) {
      if (obj.hasOwnProperty(key)) {
        delete obj[key]
      }
      return obj
    },
    /**
             * 初始化文件列表的请求参数
             */
    initReqParam(fileType) {
      this.reqParam = { ...this.parsedParam }
      this.deletePropertyInObj(this.reqParam, 'metadata_url')
      this.deletePropertyInObj(this.reqParam, 'code')
      this.deletePropertyInObj(this.reqParam, 'path')
      const reqParam = {
        neid_chose: this.$route.params.neid,
        neid: this.parsedParam.neid,
        file_type: isNaN(fileType) ? this.getListFileType() : fileType,
      }
      Object.assign(this.reqParam, reqParam)
      // 当前文件的类型和在列表中的定位，用于类型选择器
      const typeIndex = this.allTypeList.findIndex((element) => element.type == this.reqParam.file_type)
      this.listVal.type = this.allTypeList[typeIndex].name
    },
    /**
             * 获取可以选择的类型
             * @params {Object} typeListData 类型选择器所需参数，包括类型、当前定位和总条数
             */
    getTypeList(typeListData) {
      this.typeList = []
      this.listVal.curNum = isNaN(typeListData.curNum) ? 1 : typeListData.curNum
      this.listVal.totalNum = typeListData.totalNum
      this.hasNext = this.listVal.curNum < this.listVal.totalNum
      this.hasPre = this.listVal.curNum > 1
      if (typeListData.typeList && typeListData.typeList.length) {
        this.allTypeList.forEach((item) => {
          typeListData.typeList.forEach((i) => {
            if (item.type == i) {
              this.typeList.push(item)
            }
          })
        })
      }
    },
    /**
             * 当前文件列表数据段里，选中的数据已删除
             */
    deleteFileItem(data) {
      const vm = this
      let confirm = {
        value: true,
        isShow: true,
        title: '提示',
        isDescribe: true,
        iconType: 'warn',
        onlyOne: true,
      }
      let confirmData = {}
      if (data.srcFolderExist) {
        confirmData = {
          content: '当前预览的文件夹已被删除',
          describe: '请返回列表查看',
          sureBtn: '返回列表',
        }
        confirm = Object.assign(confirm, confirmData)
        this.$nextTick(() => {
          vm.$confirm.show({
            ...confirm,
            sure() {
              vm.reAuth() // 返回父目录
              vm.$confirm.hide()
            },
          })
        })
      } else {
        confirmData = {
          content: `${this.$t('当前预览的文件')}<span style="color: #637282;max-width: 178px;display: inline-block;height: 24px;line-height: 24px;overflow: hidden;vertical-align: text-top;text-overflow: ellipsis;white-space: nowrap;">${this.getTitle(data.selectedData.path)}</span>${this.$t('已被删除')}`,
          describe: '将为您重新获取列表文件',
          sureBtn: '刷新',
        }
        confirm = Object.assign(confirm, confirmData)
        this.$nextTick(() => {
          vm.$confirm.show({
            ...confirm,
            sure() {
              data.fn() // 删除后的跳转逻辑
              vm.$confirm.hide()
            },
          })
        })
      }
    },
    /**
             * 获取文件的title
             */
    getTitle(val) {
      if (!val) return
      const path = val.split('/')
      const len = path.length
      return path[len - 1]
    },
    /**
             * 请求底部滚动列表
             */
    onLoading({ reqParam, getRangeData, selectedItem }) {
      const url = `/v2/delivery/previewdata/${this.code}` // 拼接请求地址
      const otherParam = JSON.parse(this.$route.query.other)
      reqParam.nsid = otherParam.nsid
      delete reqParam.password
      getData(url, reqParam).then((res) => {
        const typeListData = { // 用于更新类型选择器
          typeList: res.data.filetypelist, // 当前列表有哪些类型 filetypelist
          curNum: JSON.stringify(selectedItem) == '{}' ? res.data.fileindex + 1 : selectedItem.fileindex + 1, // fileindex从0起
          totalNum: res.data.filecount, // 当前列表总条数
        }
        this.getTypeList(typeListData)
        getRangeData(res, reqParam)
      }).catch((err) => {
        // console.log(err)
        const error = err.response
        getRangeData(error, reqParam)
      })
    },
    /**
             * 底部滚动列表的切换
             */
    getSelectedData(selectedData) {
      this.selectedData = selectedData
      if (this.$route.params.neid == selectedData.neid) return // meid相同时，不重复选中
      // 更新类型选择器的当前文件定位
      this.listVal.curNum = isNaN(selectedData.fileindex) ? 1 : selectedData.fileindex + 1 // fileindex从0起
      // 更新上一下 下一页显示
      this.hasNext = this.listVal.curNum < selectedData.totalLen
      this.hasPre = this.listVal.curNum > 1
      // 更新query
      const query = this.updateQuery()
      // 更新路由
      this.$router.push({
        name: 'linkfile',
        params: { from: 'link', neid: this.selectedData.neid },
        query: { other: query },
      })
      // 如果文件类型不支持全屏，那么做全屏操作
      if (this.isFullScreen && !this.isHasFullScreen(selectedData)) {
        exitFullscreen()
        this.isFullScreen = false
      }
      this.init(false)
    },
    updateQuery() {
      // console.log('selectedData---', this.selectedData, this.parsedParam)
      const other = {
        neid: this.parsedParam.neid, // 父级neid
        nsid: this.selectedData.nsid,
        metadata_url: this.selectedData.metadata_url || '', // 当前的metadata api
        token: this.parsedParam.token, // 验证需要的token，没有就空
        password: this.parsedParam.password, // 验证需要的提取码，没有就空
        code: this.parsedParam.code, // delivery_code
        path: this.selectedData.path, // 文件的路径
        orderby: this.parsedParam.orderby, // 排序方式
        sort: this.parsedParam.sort, // 排序方式是升序还是降序
      }
      return JSON.stringify(other)
    },
    /**
             * 上一页和下一页按钮
             */
    goto(step) {
      if (typeof +step === 'number') {
        if (+step < 0 && !this.hasPre) return
        if (+step > 0 && !this.hasNext) return
        this.fileListStep += step
      }
    },
    /**
             * 获取文件所属类型
             * 截取mine_type的第一位，代表着所属类型
             */
    getListFileType() {
      const type = (this.metaData && this.metaData.mime_type) || ''
      let typeIndex
      switch (type.split('/')[0]) {
        case 'doc':
          typeIndex = 1
          break
        case 'audio':
          typeIndex = 2
          break
        case 'video':
          typeIndex = 3
          break
        case 'image':
          typeIndex = 4
          break
        case 'other':
          typeIndex = 0
          break
        default:
          typeIndex = -1
          break
      }
      return typeIndex
    },
    /**
             * 异常函数的操作事件
             */
    abnormal(key) {
      const cfg = {
        download: 'downFile', // download
        refresh: 'init', // refresh
        reinput: 'reAuth', // 请重新输入，会跳转到文件夹的验证页面
      }
      if (cfg[key]) {
        this[cfg[key]]()
      }
    },
    /**
             * 重新验证
             */
    reAuth() {
      // 更新路由
      this.$router.push({
        name: 'link',
        params: { from: 'view', neid: this.parsedParam.code },
        query: {},
      })
    },
    /**
             * 判断是否有全屏的按钮
             */
    isHasFullScreen(d) {
      const metaData = d || this.metaData
      if (!metaData.neid) {
        return false
      }
      const type = getPreviewType(metaData)
      // 如果是非pdf和图片的那么没有全屏按钮
      if ((type == 'doc' && metaData.mime_type.indexOf('.xls') === -1) || type == 'image') {
        return true
      }
      return false
    },
    /**
             * 校验doc档预览
             * 超过文件限制，或者幻灯片模式是否要预览
             */
    docCheck() {
      if (!this.metaData) {
        return false
      }
      return !isExcel(this.metaData.mime_type) && !this.isSideMode && !this.abnormalType
    },
    /**
             * 图片是否在权限上可预览
             */
    picCheck() {
      return !this.abnormalType
    },
    /**
             * 页面底部toolbar的媒体查询
             */
    setToolbarMedia(el) {
      const node = typeof el === 'string' ? this.$refs[el] : el
      let isPdf = false
      const pdfRotateExist = document.querySelector('.section-control-doc .section-rotate-area')
      if (this.metaData && this.metaData.mime_type) {
        isPdf = typeIcon(this.metaData.mime_type.toString().split('.').pop()) == 'pdf'
      } else if (pdfRotateExist) {
        isPdf = true
      }
      if (!isPdf && this.displayRightPanel) {
        node.classList.remove('screenPdf')
        node.classList.add('screenFile')
      } else if (isPdf && this.displayRightPanel) {
        node.classList.remove('screenFile')
        node.classList.add('screenPdf')
      } else {
        node.classList.remove('screenFile')
        node.classList.remove('screenPdf')
      }
    },
    /**
             * 异常报错
             */
    viewError(e) {
      if (e && e.data === 'pdfLoadError') { // 监听到pdf报错信息，调用异常组件
        this.abnormalType = 'loadFail'
      }
    },
  },
}
</script>
<style lang="less">
.link-box {
  // pdf 媒体查询
  .screenPdf{
    @media screen and (max-width: 1100px){
      .section-control{
        .section-zoom-area{
          .zoom-out{
            margin: 0 10px 0 0;
          }
          .zoom-num{
            display: none;
          }
        }
        .section-rotate-area {
          .rotate-ccw {
            margin: 0 10px 0 0;
          }
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
@import '~less/link.less';
.link-box {
  .link-box-body{
    position: absolute;
  }
  .lh-50{
    .right-pannel{
      min-width: 32px;
      padding: 0;
      .right-pannel-icon{
        width: 24px;
        height: 24px;
        vertical-align: -6px;
        display: inline-block;
      }
    }
  }
  //媒体查询 start
  @media screen and (max-width: 1200px){
    .section-control{
      float: right;
    }
  }
  // pdf 媒体查询
  .screenPdf{
    @media screen and (max-width: 1290px){
      .section-control{
        float: right;
        width: auto;
      }
    }
    @media screen and (max-width: 1280px){
      .link-box-footer .footer-toolbar {
        .section-up{
          .previous-one{
            min-width: 32px;
            padding: 0px;
            .previous-one-text{
              display: none;
            }
          }
        }
        .section-down{
          .next-one{
            min-width: 32px;
            padding: 0px;
            .next-one-text{
              display: none;
            }
          }
        }
      }
    }
    @media screen and (max-width: 1170px){
      .link-box-footer .footer-toolbar {
        .section-down{
          .drop-down-component{
            .selector-pos{
              display: none;
            }
          }
        }
      }
    }
  }
  // 其他文件媒体查询
  .screenFile {
    @media screen and (max-width: 1280px){
      .section-control{
        float: right;
        width: auto;
      }
    }
    @media screen and (max-width: 1160px) {
      .link-box-footer .footer-toolbar {
        .section-up{
          .previous-one{
            min-width: 32px;
            padding: 0px;
            .previous-one-text{
              display: none;
            }
          }
        }
        .section-down{
          .next-one{
            min-width: 32px;
            padding: 0px;
            .next-one-text{
              display: none;
            }
          }
        }
      }
    }
    @media screen and (max-width: 1070px) {
      .link-box-footer .footer-toolbar {
        .section-down{
          .drop-down-component{
            .selector-pos{
              display: none;
            }
          }
        }
      }
    }
  }
  //媒体查询 end
}
</style>
